// extracted by mini-css-extract-plugin
module.exports = {"button":"button__rONtK","dialogBody":"dialogBody__rVlMf","dialogHeader":"dialogHeader__hSXg0","form":"form__0Ai+1"};